"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var styles = function styles(theme) {
  return {
    disableAnimation: {
      "& span[style]": {
        animation: "none !important",
        backgroundImage: "none"
      }
    }
  };
};

exports.styles = styles;